<app-help-page mainVideo="report-saving-sharing"
               [tutorials]="['saved-reports', 'reports-saving-sharing', 'performance-reports', 'dashboard', 'chart-reports', 'quick-start']"
               [videos]="['report-saving-sharing', 'performance-report', 'report-templates']"></app-help-page>
